export default function() {
  return [
    {
      title: "Overview",
      to: "/overview",
      htmlBefore: '<i class="material-icons">home</i>',
      htmlAfter: "",
      role:'user'
    },
    {
      title: "Facebook Ad Spend",
      htmlBefore: '<i class="material-icons">facebook</i>',
      to: "/facebook-data",
      role:'user'
    },
    {
      title: "Klaviyo",
      htmlBefore: '<i class="material-icons">wifi</i>',
      to: "/klaviyo-data",
      role:'user'
    },
    {
      title: "Past Reports",
      htmlBefore: '<i class="material-icons">history</i>',
      to: "/past-reports",
      role:'user'
    },
    {
      title: "Edit Users Details",
      htmlBefore: '<i class="material-icons">home</i>',
      to: "/admin",
      role:'admin'
    },
    {
      title: "Create New Users",
      htmlBefore: '<i class="material-icons">person</i>',
      to: "/update-users",
      role:'admin'
    },
    {
      title: "User Reports",
      htmlBefore: '<i class="material-icons">trending_up</i>',
      to: "/admin-reports",
      role:'admin'
    },
  ];
}
